import { IAppState } from '../../common/state';
import { MOSCOW_AND_REGION } from '../../../packages/Filters/shared/constants/regions';
import { isInRegionSelector } from '../isInRegion';
import { isAbUseExperimentGroup } from '../../utils/experiments/isAbUseExperimentGroup';
import { NB_CONSULTANT_TRIGGERING_MESSAGE } from '../../constants/experiments';

export function motivationPopupOpenSelector(state: IAppState) {
  return state.newbuildingConsultant.showMotivationPopup;
}

export function motivationPopupAvailableSelector(state: IAppState) {
  const { config, isNewbuildingsOnly, abUseExperiments } = state;

  return (
    !!config.get<string>('webim.accountName') &&
    isNewbuildingsOnly &&
    isInRegionSelector(MOSCOW_AND_REGION)(state) &&
    isAbUseExperimentGroup(abUseExperiments, NB_CONSULTANT_TRIGGERING_MESSAGE, 'enabled')
  );
}
